<template>
  <div class="privacy-policy">
    <div class="policy-content">
      <div class="back-nav">
        <router-link to="/" class="back-button">
          ← Back to Home
        </router-link>
      </div>

      <h1>Privacy Policy</h1>
      
      <section>
        <h2>Information Collection and Use</h2>
        <p>MyKaraoke.World collects and processes the following information when you use our service:</p>
        <ul>
          <li><strong>Search Queries:</strong> When you search for karaoke songs, we collect your search terms to provide relevant YouTube video results.</li>
          <li><strong>Room Activity:</strong> We store information about the karaoke rooms you create or join, including:
            <ul>
              <li>Room IDs</li>
              <li>Songs added to the queue</li>
              <li>Video playback status</li>
              <li>Room participation data</li>
            </ul>
          </li>
          <li><strong>YouTube Data:</strong> We access and temporarily store YouTube video information including:
            <ul>
              <li>Video titles</li>
              <li>Thumbnails</li>
              <li>Video IDs</li>
              <li>Channel information</li>
            </ul>
          </li>
          <li><strong>Cookies and Local Storage:</strong> We store, access, and collect information directly on your device, and allow third parties to do so, including:
            <ul>
              <li>Your consent preferences (stored in browser local storage)</li>
              <li>Session data for maintaining your room connection</li>
              <li>Cookies placed by Google Analytics to track usage patterns and improve our service</li>
              <li>Browser storage for app functionality and user preferences</li>
            </ul>
          </li>
        </ul>
      </section>

      <section>
        <h2>Data Processing</h2>
        <p>Your information is processed in the following ways:</p>
        <ul>
          <li>Search queries are processed through YouTube's Data API to return karaoke video results</li>
          <li>Room data is stored in our Firebase database to maintain room state and queue information</li>
          <li>Video information is cached temporarily to improve performance</li>
          <li>Analytics data is processed to improve service quality and user experience</li>
        </ul>
      </section>

      <section>
        <h2>Information Sharing</h2>
        <p>We share information in the following ways:</p>
        <ul>
          <li><strong>Third-Party Services:</strong>
            <ul>
              <li>YouTube API Services: We share search queries and video interaction data to provide karaoke functionality</li>
              <li>Firebase: Room and user activity data is stored on Google Cloud Platform</li>
              <li>Google Analytics: Anonymous usage data for service improvement</li>
            </ul>
          </li>
          <li><strong>Other Users:</strong>
            <ul>
              <li>Room participants can see the songs you add to the queue</li>
              <li>Your room activity is visible to other participants in the same room</li>
            </ul>
          </li>
        </ul>
      </section>

      <section>
        <h2>Data Retention</h2>
        <p>We handle data retention as follows:</p>
        <ul>
          <li>Room data is automatically deleted when a room becomes inactive</li>
          <li>Search history is not permanently stored</li>
          <li>Analytics data is retained for a maximum of 14 months</li>
        </ul>
      </section>

      <section>
        <h2>Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access your personal data</li>
          <li>Request deletion of your data</li>
          <li>Opt-out of analytics collection</li>
          <li>Request information about how your data is used</li>
        </ul>
        <p>For any privacy-related questions or requests, please contact us at mykaraoke.world.official@gmail.com</p>
      </section>

      <section>
        <h2>Google Privacy Policy</h2>
        <p>This application uses Google's API Services. Please review the <a href="http://www.google.com/policies/privacy" target="_blank" rel="noopener noreferrer">Google Privacy Policy</a> to understand how Google handles your data when you use this application.</p>
      </section>
    </div>
  </div>
</template>

<style scoped>
.privacy-policy {
  min-height: 100vh;
  padding: 2rem;
  background: #1a1a1a;
  color: rgba(255, 255, 255, 0.9);
}

.policy-content {
  max-width: 800px;
  margin: 0 auto;
  text-align: left;
}

h1 {
  color: #ffa500;
  margin-bottom: 2rem;
  font-size: 2rem;
}

h2 {
  color: #ffa500;
  margin: 2rem 0 1rem;
  font-size: 1.5rem;
}

section {
  margin-bottom: 2rem;
}

p {
  margin-bottom: 1rem;
  line-height: 1.6;
}

ul {
  margin: 1rem 0;
  padding-left: 1.5rem;
}

ul ul {
  margin: 0.5rem 0;
}

li {
  margin-bottom: 0.5rem;
  line-height: 1.6;
}

strong {
  color: rgba(255, 255, 255, 0.95);
}

a {
  color: #ffa500;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .privacy-policy {
    padding: 1rem;
  }

  h1 {
    font-size: 1.75rem;
  }

  h2 {
    font-size: 1.25rem;
  }
}

.back-nav {
  margin-bottom: 2rem;
}

.back-button {
  display: inline-flex;
  align-items: center;
  color: #ffa500;
  text-decoration: none;
  font-size: 1rem;
  padding: 0.5rem;
  transition: color 0.2s;
}

.back-button:hover {
  color: #ff9500;
}
</style> 